import { render, staticRenderFns } from "./KernelOrderStatusesChart.vue?vue&type=template&id=117b9afe&"
import script from "./KernelOrderStatusesChart.vue?vue&type=script&lang=js&"
export * from "./KernelOrderStatusesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports